<template>
  <div>
    <vx-card collapse-action refresh-content-action @refresh="closeCardAnimationDemo" title="IFTA Reports">
      <div class="px-3 py-2 flex flex-col gap-8">

        <TableSortForm @update-object="updateObject" :active="active" :fetchParams="fetchParams" />

        <div class="flex box-border justify-between border-0 border-b border-solid border-silver-gray">
          <div class="flex  gap-1">
            <vs-button @click="setActive('Untis')" :class="`rounded-none  ${active !== 'Untis' && 'text-black bg-soft-gray'
              }`">
              Untis
            </vs-button>
            <vs-button @click="setActive('States')" :class="`rounded-none  ${active !== 'States' && 'text-black bg-soft-gray'
              }`">
              States
            </vs-button>
          </div>
          <div>
            <vs-button @click="changeModalOpen(true)" class="rounded-none">
              Generate Report
            </vs-button>
          </div>

        </div>

        <div>
          <h3 class="pb-6">Total miles</h3>
          <div class="flex gap-16">
            <div class="flex flex-col py-2 px-5 gap-1">
              <p class="text-sm font-semibold">IFTA miles</p>
              <p class="text-black text-sm font-semibold">{{ table.total_miles }}</p>
            </div>
            <div
              class="flex flex-col gap-1 border-solid box-border self-center py-2 px-5 border-0 border-l border-silver-gray">
              <p class="text-sm font-semibold">Non-IFTA miles</p>
              <p class="text-black text-sm font-semibold">{{ non_miles }}</p>
            </div>
            <div
              class="flex flex-col gap-1 border-solid box-border self-center py-2 px-5 border-0 border-l border-silver-gray">
              <p class="text-sm font-semibold">Total miles</p>
              <p class="text-black text-sm font-semibold">{{ table.total_miles }}</p>
            </div>
          </div>
        </div>

        <UntisTable v-if="active === 'Untis'" :tableData="table" />
        <StatesTable v-if="active === 'States'" :tableData="table" />

      </div>
    </vx-card>

    <GenerateModal v-show="generateModalOpen" @cancel="changeModalOpen(false)" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import UntisTable from "./components/UntisTable/UntisTable.vue";
import StatesTable from "./components/StatesTable/StatesTable.vue";
import TableSortForm from "./components/TableSortForm/TableSortForm.vue";
import GenerateModal from "./components/GenerateModal/GenerateModal.vue";

export default {
  components: {
    vSelect,
    UntisTable,
    StatesTable,
    TableSortForm,
    GenerateModal
  },
  data() {
    return {
      viehiles: "",
      active: "Untis",
      fetchParams: {
        year: new Date().getFullYear(),
        month: new Date().toLocaleString('en-US', { month: 'long' })
      },
      generateModalOpen: false,

      non_miles: "0",
    };
  },
  methods: {
    setActive(section) {
      this.active = section;
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.fetchTableData();
      }, 3000);
    },
    fetchTableData() {
      switch (this.active) {
        case "Untis":
          this.$store.dispatch("reports/fetchUnitsTable", this.fetchParams);
          break;
        case "States":
          this.$store.dispatch("reports/fetchStateTable", this.fetchParams);
          break;
      }
    },
    changeModalOpen(value) {
      this.generateModalOpen = value;
    },
    updateObject(newData) {
      this.fetchParams = newData;
    },
  },
  created() {
    switch (this.active) {
      case "Untis":
        this.$store.dispatch("reports/fetchUnitsTable", this.fetchParams);
        this.$store.dispatch('reports/fetchVehicles')
        break;
    }
  },
  computed: {
    table() {
      return this.$store.state.reports.table;
    },
  }
};
</script>
